import React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  WithStyles,
  withStyles,
  List,
  ListItem,
  ListItemText,
  Theme,
  Divider,
} from "@material-ui/core";
import { INSPECTION_CAPTURE_TYPES } from "../constants/constants";
const styles = (theme: Theme) =>
  createStyles({
    chip: {
      margin: theme.spacing(0.5),
    },
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  handleClose: any;
  handleOnSubmit: any;
}
class SelectInspectionCaptureTypeDialog extends React.Component<Props> {
  state = {
    searchText: "",
  };
  render() {
    const { title, open, handleClose, handleOnSubmit, classes } = this.props;
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
        >
          <DialogTitle id="form-dialog-title">{title}</DialogTitle>
          <DialogContent>
            <List className={classes.root}>
              <ListItem
                button
                onClick={() => {
                  handleOnSubmit(INSPECTION_CAPTURE_TYPES.NORMAL);
                }}
              >
                <ListItemText
                  primary="Normal Inspection"
                  secondary="Inspection with Question/Forms"
                />
              </ListItem>
              <Divider />
              <ListItem
                button
                onClick={() => {
                  handleOnSubmit(INSPECTION_CAPTURE_TYPES.WORKFLOW);
                }}
              >
                <ListItemText
                  primary="Workflow Inspection"
                  secondary="Workflow Inspection with Steps"
                />
              </ListItem>
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(SelectInspectionCaptureTypeDialog);
